import { Collapse, Grid, IconButton } from "@material-ui/core";
import { activityInvoiceStyles } from "./style";
import EditIcon from "@material-ui/icons/Edit";
import { useState } from "react";
import EditActivityInvoiceDetail from "./EditActivityInvoiceDetail/EditActivityInvoiceDetail";
import { activityDetailsColumns } from "../../activityInvoiceConsts";

const ActivityInvoiceDetails = ({ invoiceDetail, expanded, canEdit }) => {
    const classes = activityInvoiceStyles();

    const [open, setOpen] = useState(false);
    const [invoiceToEdit, setInvoiceToEdit] = useState(invoiceDetail);

    const onEditClick = () => {
        setInvoiceToEdit(invoiceDetail);
        setOpen(true)
    }

    return (
        <>
            <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapseWrapper}>
                <Grid container className={classes.detailsWrapper} spacing={2} justifyContent="space-between">
                    {activityDetailsColumns?.map((col, index) =>
                        <Grid className={classes.column} xs={col.size ?? 1} item container direction='column' key={`col_${index}`}>
                            <Grid className={classes.label}>
                                {col?.label}
                            </Grid>
                            <Grid className={classes.field}>
                                {col.value ? col.value(invoiceDetail?.[col.key] ?? 0) : invoiceDetail?.[col.key] ?? 0}
                            </Grid>
                        </Grid>)}
                    {/* <Grid className={classes.column} xs={1} item >
                        <IconButton disabled={!canEdit} className={classes.iconButton} variant="outlined" onClick={onEditClick}><EditIcon /></IconButton>
                    </Grid> */}
                </Grid>
            </Collapse>
            <EditActivityInvoiceDetail invoice={invoiceDetail} open={open} setOpen={setOpen} invoiceToEdit={invoiceToEdit} setInvoiceToEdit={setInvoiceToEdit}/>
        </>
    )
}

export default ActivityInvoiceDetails;